export type InvoiceMatchSuggestion = {
    id: number;
    amount_cents: number;
    booking_date: string | null;
    counterparty: string | null;
    purpose: string | null;
    score: number;
    match_flags: {
        name?: boolean;
        amount?: boolean;
        purpose?: boolean;
        date?: boolean;
        is_installment?: boolean;
    } | null;
};

const SECURE_MATCH_SCORE = 9;

export const getSecureMatchSuggestions = (suggestions?: InvoiceMatchSuggestion[] | null) =>
    suggestions?.filter((suggestion) => suggestion.score >= SECURE_MATCH_SCORE) ?? [];

const formatAmount = (amountCents: number) =>
    new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Math.abs(amountCents) / 100);

export const MatchSuggestionTooltip = ({ suggestions }: { suggestions?: InvoiceMatchSuggestion[] | null }) => {
    const secureSuggestions = getSecureMatchSuggestions(suggestions);
    const suggestion = secureSuggestions[0];
    if (!suggestion) return <>Zahlungen verwalten</>;

    const matches = [
        suggestion.match_flags?.amount && 'Betrag',
        suggestion.match_flags?.name && 'Name',
        suggestion.match_flags?.purpose && 'Verwendungszweck',
        suggestion.match_flags?.date && 'Datum',
        suggestion.match_flags?.is_installment && 'Teilzahlung'
    ].filter(Boolean);
    const bookingDate = suggestion.booking_date ? new Date(suggestion.booking_date).toLocaleDateString('de-DE') : null;

    return (
        <div className="tw-max-w-xs tw-space-y-1.5 tw-text-left">
            <div className="tw-font-semibold">Möglicher Zahlungstreffer</div>
            <div className="tw-text-xs">
                {formatAmount(suggestion.amount_cents)}
                {suggestion.counterparty ? ` · ${suggestion.counterparty}` : ''}
                {bookingDate ? ` · ${bookingDate}` : ''}
            </div>
            {matches.length > 0 && (
                <div className="tw-text-xs tw-text-accents-6">Übereinstimmung: {matches.join(', ')}</div>
            )}
            {secureSuggestions.length > 1 && (
                <div className="tw-text-xs tw-text-accents-6">
                    + {secureSuggestions.length - 1} weitere starke Treffer
                </div>
            )}
        </div>
    );
};
